import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/qspc/',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
     {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '清水文化云'
          }
        },  {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/news'], resolve),
          meta: {
            title: '看资讯'
          },
          children: []
        }, {
          path: '/newsO',
          name: 'newsO',
          component: resolve => require(['@/view/newsO'], resolve),
          meta: {
            title: '文化资讯'
          },
          children: []
        },  {
          path: '/newsT',
          name: 'newsT',
          component: resolve => require(['@/view/newsT'], resolve),
          meta: {
            title: '非遗保护'
          },
          children: []
        },  {
          path: '/newsTh',
          name: 'newsTh',
          component: resolve => require(['@/view/newsTh'], resolve),
          meta: {
            title: '学才艺'
          },
          children: []
        }, {
          path: '/activity',
          name: 'activity',
          component: resolve => require(['@/view/activity'], resolve),
          meta: {
            title: '最新活动'
          }
        }, {
          path: '/activityO',
          name: 'activityO',
          component: resolve => require(['@/view/activityO'], resolve),
          meta: {
            title: '享活动'
          }
        }, {
          path: '/activityT',
          name: 'activityT',
          component: resolve => require(['@/view/activityT'], resolve),
          meta: {
            title: '赶大集'
          }
        }, {
          path: '/venue',
          name: 'venue',
          component: resolve => require(['@/view/venue'], resolve),
          meta: {
            title: '场馆预约'
          }
        }, {
          path: '/venueO',
          name: 'venueO',
          component: resolve => require(['@/view/venueO'], resolve),
          meta: {
            title: '订场馆'
          }
        }, {
          path: '/venueT',
          name: 'venueT',
          component: resolve => require(['@/view/venueT'], resolve),
          meta: {
            title: '精品共享'
          }
        },{
          path: '/creation',
          name: 'creation',
          component: resolve => require(['@/view/creation'], resolve),
          meta: {
            title: '辅助创作'
          }
        }, {
          path: '/classroom',
          name: 'classroom',
          component: resolve => require(['@/view/classroom'], resolve),
          meta: {
            title: '文化课堂'
          }
        }, {
          path: '/classroomO',
          name: 'classroomO',
          component: resolve => require(['@/view/classroomO'], resolve),
          meta: {
            title: '看直播'
          }
        }, {
          path: '/classroomT',
          name: 'classroomT',
          component: resolve => require(['@/view/classroomT'], resolve),
          meta: {
            title: '文化配送'
          }
        }, {
          path: '/classroomTh',
          name: 'classroomTh',
          component: resolve => require(['@/view/classroomTh'], resolve),
          meta: {
            title: '特色文化'
          }
        },
        {
          path: '/search',
          name: 'search',
          component: () => import('../../src/view/search'),
          meta: {
            title: '搜索'
          }
        },
        {
          path: '/actDetail',
          name: 'actDetail',
          component: () => import('../components/actDetail'),
          meta: {
            title: '活动详情'
          }
        },
        {
          path: '/classRoomDetail',
          name: 'classRoomDetail',
          component: () => import('../components/classRoomDetail'),
          meta: {
            title: '课堂详情'
          }
        },
        {
          path: '/newsDetail',
          name: 'newsDetail',
          component: () => import('../components/newsDetail'),
          meta: {
            title: '资讯详情'
          }
        },
        {
          path: '/venueDetail',
          name: 'venueDetail',
          component: () => import('../components/venueDetail'),
          meta: {
            title: '场馆详情'
          }
        },
        // {
        //   path: '/liveDetail',
        //   name: 'liveDetail',
        //   component: () => import('../components/liveDetail'),
        //   meta: {
        //     title: '直播详情'
        //   }
        // },
        // {
        //   path: '/ichDetail',
        //   name: 'ichDetail',
        //   component: () => import('../components/ichDetail'),
        //   meta: {
        //     title: '非遗详情'
        //   }
        // },
        // {
        //   path: '/cultureDetail',
        //   name: 'cultureDetail',
        //   component: () => import('../components/cultureDetail'),
        //   meta: {
        //     title: '特色文化服务'
        //   }
        // },
        // {
        //   path: '/volunteerDetail',
        //   name: 'volunteerDetail',
        //   component: () => import('../components/volunteerDetail'),
        //   meta: {
        //     title: '志愿者服务详情'
        //   }
        // },
        // {
        //   path: '/goodsDetail',
        //   name: 'goodsDetail',
        //   component: () => import('../components/goodsDetail'),
        //   meta: {
        //     title: '赶大集详情'
        //   }
        // },
        // {
        //   path: '/shareDetail',
        //   name: 'shareDetail',
        //   component: () => import('../components/shareDetail'),
        //   meta: {
        //     title: '精品共享详情'
        //   }
        // },
        {
          path: '/subHomePage',
          name: 'subHomePage',
          component: () => import('./../view/subPageHome'),
          meta: {
            title: ''
          }
        },
      ]
    },
  ]
})

/**
 * 路由跳转
 * @param link String
 */
// eslint-disable-next-line func-names
Router.prototype.openPage = function (link, query) {
  this.push({
      path: link,
      query: Object.assign({
          // time: new Date().getTime()
      }, query || {})
  })
};




// WEBPACK FOOTER //
// ./src/router/index.js